export const UUID_ZERO = '00000000-0000-0000-0000-000000000000';
